module.exports = __webpack_public_path__ + "static/How-Cupping-Therapy-Can-Enhance-Your-Physical-Therapy-Results-93a81ab40bde778deed87735907aa85b.webp";